import { submitFormJson } from 'widgets/toolbox/ajax';
import { setCookie } from 'widgets/toolbox/cookie';

const SERVICE_CHANGE_EVENT = 'consentServiceChange';
const SERVICE_PERSONALIZATION = 'Salesforce Personalisation & Tracking';

function CoreConsentTrackingClassCreator(ConsentTracking: import('widgets/global/ConsentTracking').TConsentTracking) {
    class CoreConsentTracking extends ConsentTracking {
        init() {
            this.eventBus().on(SERVICE_CHANGE_EVENT, 'processServiceChange');
            this.eventBus().emit('consentServiceRequest', SERVICE_PERSONALIZATION);
        }

        /**
         * @description Handles changes to service consent, specifically for personalization services.
         * @param type - The type of service for which the consent change is being processed.
         * @param accepted - A boolean indicating whether the consent was accepted or declined.
         */
        processServiceChange(type, accepted) {
            if (type === SERVICE_PERSONALIZATION) {
                this.processConsentChange(accepted);
            }
        }

        /**
         * @description Processes the user's consent change by invoking the appropriate handler.
         * @param accepted - A boolean indicating whether the user has accepted (true) or rejected (false) consent.
         */
        processConsentChange(accepted) {
            if (accepted) {
                this.accept();
            } else {
                this.reject();
            }
        }

        /**
         * @description Accept Consent handler
         * @listens dom#click
         * @returns Promise object represents server response for consent tracking accepting
         */
        accept(): Promise<Record<string, unknown>> {
            return submitFormJson(this.prefs().acceptUrl, undefined, 'POST').finally(() => {
                setCookie('dw_consent_cookie', '1', 365, true);
            });
        }

        /**
         * @description Reject Consent handler
         * @listens dom#click
         * @returns Promise object represents server response for consent tracking rejection
         */
        reject(): Promise<Record<string, unknown>> {
            return submitFormJson(this.prefs().rejectUrl, undefined, 'POST');
        }
    }

    return CoreConsentTracking;
}

export type TCoreConsentTracking = ReturnType<typeof CoreConsentTrackingClassCreator>;

export type TCoreConsentTrackingInstance = InstanceType<TCoreConsentTracking>;

export default CoreConsentTrackingClassCreator;
